import React, { useState } from 'react'
import PDFViewer from './PDFViewer'

function PDFViewerTest(): JSX.Element {
  const [showViewer, setShowViewer] = useState(false)
  const testPDFUrl = 'https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf'

  return (
    <div style={{ padding: '40px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>PDF Viewer Test Page</h1>
      
      <section style={{ marginBottom: '40px' }}>
        <h2>Features</h2>
        <ul>
          <li>✅ Page-by-page navigation with prev/next buttons</li>
          <li>✅ Zoom controls (50% to 300%)</li>
          <li>✅ Keyboard shortcuts (arrow keys, +/-, Home/End, ESC)</li>
          <li>✅ Download PDF functionality</li>
          <li>✅ High-quality canvas rendering</li>
          <li>✅ Automatic fallback to iframe if PDF.js fails</li>
          <li>✅ Dark theme matching photo gallery</li>
        </ul>
      </section>

      <section style={{ marginBottom: '40px' }}>
        <h2>Keyboard Shortcuts</h2>
        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr style={{ backgroundColor: '#f0f0f0' }}>
              <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Key</th>
              <th style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'left' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>← / → or ↑ / ↓</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>Navigate pages</td>
            </tr>
            <tr>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>+ / =</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>Zoom in</td>
            </tr>
            <tr>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>- / _</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>Zoom out</td>
            </tr>
            <tr>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>Home</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>First page</td>
            </tr>
            <tr>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>End</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>Last page</td>
            </tr>
            <tr>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>ESC</td>
              <td style={{ padding: '10px', border: '1px solid #ddd' }}>Close viewer</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section>
        <h2>Test PDF Viewer</h2>
        <button
          onClick={() => setShowViewer(!showViewer)}
          style={{
            padding: '12px 24px',
            fontSize: '16px',
            backgroundColor: '#0078d4',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            marginBottom: '20px'
          }}
        >
          {showViewer ? '✕ Close Viewer' : '📄 Open Test PDF'}
        </button>

        {showViewer && (
          <div style={{
            border: '2px solid #ddd',
            borderRadius: '8px',
            overflow: 'hidden',
            height: '800px',
            backgroundColor: '#525659'
          }}>
            <PDFViewer
              url={testPDFUrl}
              title="Sample PDF Document"
              isFullscreen={false}
            />
          </div>
        )}
      </section>

      <section style={{ marginTop: '40px', padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
        <h3>Implementation Notes</h3>
        <p><strong>Components:</strong></p>
        <ul>
          <li><code>PDFViewer.tsx</code> - Main PDF viewer component with controls</li>
          <li><code>Home.tsx</code> - Gallery integration for public view</li>
          <li><code>PhotoManager.tsx</code> - Admin panel integration</li>
        </ul>
        
        <p><strong>Backend Support:</strong></p>
        <ul>
          <li>PDF file type detection during upload</li>
          <li>SVG thumbnail generation</li>
          <li>S3 storage with proper content type</li>
        </ul>

        <p><strong>Gallery Integration:</strong></p>
        <ul>
          <li>PDFs show with 📄 icon and red tint in thumbnail grid</li>
          <li>Click to open in fullscreen modal with PDF viewer</li>
          <li>Seamless integration with existing photo/video navigation</li>
        </ul>
      </section>
    </div>
  )
}

export default PDFViewerTest
